<template>
    <div class="pageBox">
        <div class="frame">
            <div class="box nav">
                <span>当前位置：</span>
                <router-link to="/Resource">资源中心</router-link>
                &nbsp;>&nbsp;
                <router-link to="/Resource">中安新闻</router-link>
                &nbsp;>&nbsp;
                <span>{{ newsTitle }}</span>
            </div>
        </div>
        <div class="frame news">
            <div class="box">
                <div class="title">{{ newsTitle }}</div>
                <div class="timeRow">
                    <div class="time">{{ newsTime }}</div>
                    <div class="scan">阅读量：{{ newsScan }}</div>
                </div>
                <div class="content" v-html="newsContent"></div>
                <div class="fileRow" v-if="newsFile!=null">
                    <div class="fileTitle">附件：</div>
                    <a target="_blank" :href="newsFile" class="file">
                        <img src="../assets/images/downloadDocument.png" alt="附件下载">
                    </a>
                </div>
                <div class="pageTurning">
                    <router-link :to="prevId==0?{path: $route.fullPath}:{name:'NewsDetail',params:{nId:prevId}}"
                                 :class="{disabled:prevId==0}"
                                 class="pageBlock">
                        <span class="pageBtn">上一篇：</span>
                        <span class="name">{{ prevTitle }}</span>
                    </router-link>
                    <router-link :to="nextId==0?{path: $route.fullPath}:{name:'NewsDetail',params:{nId:nextId}}"
                                 :class="{disabled:nextId==0}"
                                 class="pageBlock">
                        <span class="pageBtn">下一篇：</span>
                        <span class="name">{{ nextTitle }}</span>
                    </router-link>
                </div>
                <router-link to="/Resource" class="back">返回</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "newsDetail",
    data() {
        return {
            newsTitle: '',
            newsTime: '',
            newsScan: 0,
            newsContent: '',
            prevTitle: '',
            prevId: 0,
            nextTitle: '',
            newsFile: '',
            nextId: 0,
        }
    },
    mounted() {
        this.$store.commit('setNav', 4)
        this.getNewsDetail(this.$route.params.nId)
        this.updateScan(this.$route.params.nId)
    },
    watch: {
        '$route.params.nId'() {
            this.getNewsDetail(this.$route.params.nId)
        }
    },
    methods: {
        /**
         * 获取新闻详情
         */
        getNewsDetail(id) {
            this.$post('/V1/News/GetNewsDetail',
                {
                    "id": id
                })
                .then((res) => {
                    // console.log('NewsDetail', res)
                    if (res.success) {
                        this.newsTitle = res.response.newsInfo.newsTitle
                        this.newsTime = res.response.newsInfo.baseModifyTime
                        this.newsScan = res.response.newsInfo.viewNumber
                        this.newsContent = res.response.newsInfo.newsContent
                        this.newsFile = res.response.newsInfo.newsFile
                        if (res.response.prev != null) {
                            this.prevTitle = res.response.prev.title
                            this.prevId = res.response.prev.id
                        } else {
                            this.prevTitle = '没有了'
                            this.prevId = 0
                        }
                        if (res.response.next != null) {
                            this.nextTitle = res.response.next.title
                            this.nextId = res.response.next.id
                        } else {
                            this.nextTitle = '没有了'
                            this.nextId = 0
                        }
                        document.title = this.newsTitle + this.$suffix
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
        },

        /**
         * 更新浏览量
         */
        updateScan(id) {
            this.$post('/V1/News/UpdateViewNumber', {
                id: id
            })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        }
    }
}
</script>

<style scoped lang="less">
.pageBox {
    display: flex;
    flex-direction: column;

    .frame {
        width: 100%;
        background-color: #f9f9f9;

        .box {
            width: 1210px;
            margin: 0 auto;
        }

        .nav {
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #666666;
            font-size: 16px;
            height: 40px;
            line-height: 40px;

            a {
                color: #333
            }
        }
    }

    .news {
        display: flex;
        flex-direction: column;
        padding: 40px 0px;
        background-color: white;

        .title {
            font-size: 24px;
            color: #333;
            width: 100%;
            margin-bottom: 30px;
        }

        .timeRow {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 14px;
            color: #999;
            margin-bottom: 40px;

            .time {
                margin-right: 100px;
            }
        }

        .content {
            width: 100%;
            overflow: hidden;

            img, table {
                max-width: 100%;
            }
        }

        .fileRow {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            width: fit-content;

            .fileTitle {
                font-size: 16px;
                margin-bottom: 3px;
            }

            .file {

                img {
                    margin-right: 5px;
                }
            }
        }

        .pageTurning {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-top: 60px;

            .pageBlock {
                max-width: 590px;
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 15px;
                cursor: pointer;
                color: #999;

                .pageBtn {
                    width: 60px;
                    min-width: 60px;
                }

                .name {
                    max-width: 530px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .disabled {
                cursor: not-allowed;
                color: #ccc;
            }
        }

        .back {
            display: block;
            width: 80px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background-color: #1f2d5c;
            border-radius: 4px;
            color: white;
            font-size: 15px;
            margin: 40px auto 0px;
        }
    }
}
</style>
